import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { OpendialogShowListingComponent } from 'app/components/dialog/open-dialog-show-listing/opendialog-show-listing.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-practice-place',
  templateUrl: './practice-place.component.html',
  styleUrls: ['./practice-place.component.scss']
})
export class PracticePlaceComponent implements OnInit {

  @Input() userConnected: InfosUser;

  practicePlace: PracticePlace[];
  clubCode: any;

  constructor(
    private practicePlaceService: PracticePlaceService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private tooltip: TooltipService,
    private faIconService: FaiconService,

  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  openDialogShowListing(list: any, typeList: string): void {
    this.dialog.open(OpendialogShowListingComponent, {
      data: { list, typeList }
    });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private getPracticePlaceByClub(clubCode: string): void {
    this.practicePlaceService.getPracticePlaceByClub(clubCode).subscribe({
      next: paticePlace => this.practicePlace = paticePlace
    });
  }

  private initComponent(): void {
    this.clubCode = this.route.snapshot.queryParams.clubCode || this.userConnected.club_code;

    switch (this.userConnected.role) {
      case 'club':
        this.getPracticePlaceByClub(this.userConnected.club_code);
        break;

      case 'admin':
        const { clubCode } = this.route.snapshot.queryParams;
        this.getPracticePlaceByClub(clubCode);
        break;

      default:
        break;
    }
  }
}
